(() => {
 const norm=s=>String(s||'').toLowerCase().replace(/([0-9])([a-z])/g,'$1 $2').replace(/([a-z])([0-9])/g,'$1 $2').replace(/[^a-z0-9]+/g,' ').trim();
 function select(cards,limit,query){
  const exact=[],strong=new Map(),related=new Map(),seen=new Set(),words=norm(query).split(' ').filter(Boolean),age=norm(query).match(/\b(\d+)\s+jaar\b/);
  for(const card of cards){
   const id=card.dataset.searchFamily||card.dataset.productId;if(seen.has(id))continue;seen.add(id);
   const title=norm(card.dataset.searchTitle);
   if(title===norm(query)){exact.push(card);continue;}
   const titleWords=title.split(' '),buckets=(!age||(' '+title+' ').includes(' '+age[0]+' '))&&words.every(word=>titleWords.some(candidate=>candidate===word||(!/^\d+$/.test(word)&&candidate.startsWith(word))))?strong:related;
   const key=card.dataset.searchType||'other';if(!buckets.has(key))buckets.set(key,[]);buckets.get(key).push(card);
  }
  const output=exact.slice(0,limit);
  for(const buckets of [strong,related])while(output.length<limit){let added=false;for(const bucket of buckets.values()){if(bucket.length&&output.length<limit){output.push(bucket.shift());added=true;}}if(!added)break;}
  return output;
 }
 window.FXLSearchDiversity={select};
})();
